module.exports = __webpack_public_path__ + "assets/icona_immagine.6826338e.svg";